const path = require('path');

module.exports = {
    i18n: {
        lng: 'de',
        defaultLocale: 'de',
        supportedLngs: ['en', 'de', 'it'],
        locales: ['en', 'de', 'it'],
        fallbackLng: 'de'
    },
    reloadOnPrerender: process.env.NODE_ENV === 'development',
    localePath: path.resolve('./public/locales'),
    defaultNS: 'translation',
    react: {
        useSuspense: false,
    },
};